module.exports = {
  App: {
    Agreement: '请阅读并同意用户协议'
  }
}
